import { useState } from 'react';
import useAuth from '../../hooks/useAuth';

/**
 * ClaimGardensPrompt — subtle banner prompting anonymous users to save their gardens.
 *
 * Shown only when:
 *  - User is NOT authenticated
 *  - At least one garden ID is stored in localStorage ('my_garden_ids')
 *  - The prompt has not been dismissed in this session
 *
 * Brand principle: no pressure, no exclamation marks, easy to dismiss.
 */
const ClaimGardensPrompt = () => {
  const { isAuthenticated } = useAuth();
  const [dismissed, setDismissed] = useState(
    () => localStorage.getItem('claim_prompt_dismissed') === 'true'
  );

  const gardenIds = JSON.parse(localStorage.getItem('my_garden_ids') || '[]');

  if (isAuthenticated || gardenIds.length === 0 || dismissed) return null;

  const handleDismiss = () => {
    setDismissed(true);
    localStorage.setItem('claim_prompt_dismissed', 'true');
  };

  return (
    <div className="bg-emerald-50 border border-emerald-200 rounded-lg px-4 py-3 flex items-center justify-between gap-4">
      <p className="text-sm text-gray-700">
        Möchtest du deine Gärten sichern, um sie auf anderen Geräten zu nutzen?
      </p>
      <div className="flex items-center gap-3 flex-shrink-0">
        <a
          href="/login"
          className="text-sm font-medium text-emerald-600 hover:underline whitespace-nowrap"
        >
          E-Mail eingeben
        </a>
        <button
          type="button"
          onClick={handleDismiss}
          className="text-sm text-gray-500 hover:underline whitespace-nowrap"
        >
          Später
        </button>
      </div>
    </div>
  );
};

export default ClaimGardensPrompt;
